import { render, staticRenderFns } from "./TeamOvertimeMain.vue?vue&type=template&id=28082f28"
import script from "./TeamOvertimeMain.vue?vue&type=script&lang=js"
export * from "./TeamOvertimeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports